<section class="faq" id="faqs">
    <div class="container">

      <div class="row justify-content-center">
        <div class="col-12">
            <div class="text-start">
              <h2 class="main-heading text-light fw-bold text-center"><img src="/assets/images/svg-icons/star-icon.svg" class="img-fluid star-icon"/>{{ 'faq-head' | translate }}</h2>
              <!-- <p class="sub-text font-14 font-sm-18">
                {{ 'faq-para' | translate }}
              </p> -->
            </div>
          </div>
        <div class="col-md-10">
          <div *ngFor="let item of data;let i = index;" >
            <div class="accordion-wrapper">
              <button class="accordion" (click)="toggleAccordian($event, i)"> {{item.parentName | translate}} </button>
              <div class="panel" hide="!item.isActive">
                <p *ngFor="let child of item.childProperties" class="fw-regular font-16 px-4 pb-4 mb-2">{{child.propertyName | translate}} </p>
              </div>
            </div>
    
          </div>
        </div>
      </div>
    </div>
  </section>
  